var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { CreateColumn } from "../utilities/sfAnalytics";
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main(options) {
        var _this = _super.call(this, options) || this;
        _this.ItemsToDisplay = [];
        _this.FrenchForms = { Translations: { Review: 'Réviser', Text: 'Prière  de reviser  les informations  suivantes que vous  avez entrées sont correctes . Faire le changement si necessaire , ou proceder avec la soumission.', Submit: 'Soumettre', Edit: 'Modifier' }, FormIds: [31, 30, 29, 32] };
        _this.SpanishForms = { Translations: { Review: 'Revision', Text: 'Por favor revisa que la información sea correcta. Haz cambios si es necesario o  procede a completar el formulario..', Submit: 'Completar', Edit: 'Editar' }, FormIds: [22, 23, 24, 25] };
        _this.EnglishForms = { Translations: { Review: 'Review', Text: 'Please review the following information that you entered is correct. Make changes as necessary, or proceed with submitting.', Submit: 'Submit', Edit: 'Edit' }, FormIds: [16, 18, 19, 34, 38, 39, 40, 45, 20] };
        _this.GermanForms = { Translations: { Review: 'Überprüfen', Text: 'Bitte überprüfen Sie die folgenden, von Ihnen angegebenen, Daten auf Richtigkeit. Nehmen Sie Änderungen vor, oder gehen Sie auf „Senden“', Submit: 'Einreichen', Edit: 'Bearbeiten' }, FormIds: [36, 46, 47, 48] };
        _this.ReviewText = '';
        _this.GeneralText = '';
        _this.SubmitText = '';
        _this.EditText = '';
        return _this;
    }
    Main.prototype.created = function () {
        var _this = this;
        rnJQuery(function () {
            var formId = smartFormsLoadedItems[0].form_id;
            var translations;
            if (_this.FrenchForms.FormIds.indexOf(parseInt(smartFormsLoadedItems[0].form_id)) >= 0)
                translations = _this.FrenchForms;
            if (_this.SpanishForms.FormIds.indexOf(parseInt(smartFormsLoadedItems[0].form_id)) >= 0)
                translations = _this.SpanishForms;
            if (_this.EnglishForms.FormIds.indexOf(parseInt(smartFormsLoadedItems[0].form_id)) >= 0)
                translations = _this.EnglishForms;
            if (_this.GermanForms.FormIds.indexOf(parseInt(smartFormsLoadedItems[0].form_id)) >= 0)
                translations = _this.GermanForms;
            if (translations == null)
                translations = _this.EnglishForms;
            _this.ReviewText = translations.Translations.Review;
            _this.GeneralText = translations.Translations.Text;
            _this.originalSendToSmartForms = smartFormsLoadedItems[0].SendToSmartForms;
            _this.originalSaveComplete = smartFormsLoadedItems[0].SaveCompleted;
            _this.SubmitText = translations.Translations.Submit;
            _this.EditText = translations.Translations.Edit;
            smartFormsLoadedItems[0].SendToSmartForms = function (formValues, isUsingFileUploader) { _this.NewSendToSmartForms(formValues, isUsingFileUploader); };
            smartFormsLoadedItems[0].SaveCompleted = function (result, formValues) { return _this.SaveComplete(result, formValues); };
        });
    };
    Main.prototype.Edit = function () {
        var _this = this;
        smartFormsLoadedItems[0].JQueryForm.parent().find('input[type="submit"],.redNaoMSButton').removeAttr('disabled');
        rnJQuery(this.$refs.container).velocity({ opacity: 0 }, 300, 'easeOutExp', function () {
            rnJQuery(_this.$refs.container).css('display', 'none');
            smartFormsLoadedItems[0].JQueryForm.parent().css('display', 'block').velocity({ opacity: 1 }, 300, 'easeInExp');
        });
    };
    Main.prototype.NewSendToSmartForms = function (formValues, isUsingFileUploader) {
        var _this = this;
        debugger;
        this.formValues = formValues;
        this.isUsingFileUploader = isUsingFileUploader;
        smartFormsLoadedItems[0].JQueryForm.parent().velocity({ opacity: 0 }, 300, 'easeOutExp', function () {
            _this.ItemsToDisplay = [];
            smartFormsLoadedItems[0].JQueryForm.parent().css('display', 'none');
            rnJQuery(_this.$refs.container).css('display', 'block').velocity({ opacity: 1 }, 300, 'easeInExp');
            _this.GenerateSummary(formValues);
        });
    };
    Main.prototype.GenerateSummary = function (formValues) {
        debugger;
        var _loop_1 = function (fieldId) {
            var field = window.smartFormsLoadedItems[0].FormElements.find(function (x) { return x.Id == fieldId; });
            if (field == null || !field.StoresInformation())
                return "continue";
            if (field.Options.ClassName == "rednaorepeater") {
                for (var i = 0; i < field.Fields.length; i++) {
                    var index = parseInt(field.Fields[i].Id.substring(field.Fields[i].Id.lastIndexOf('_') + 1));
                    this_1.AddRow(field.Fields[i], formValues[fieldId].value[index], field.Fields[i].Options.Id, ' #' + (index + 1));
                }
            }
            else
                this_1.AddRow(field, formValues, fieldId);
        };
        var this_1 = this;
        for (var fieldId in formValues) {
            _loop_1(fieldId);
        }
    };
    Main.prototype.Submit = function () {
        rnJQuery(this.$refs.submit).RNWait('start');
        this.originalSendToSmartForms.call(smartFormsLoadedItems[0], this.formValues, this.isUsingFileUploader);
    };
    Main.prototype.AddRow = function (field, formValues, fieldId, sufix) {
        if (sufix === void 0) { sufix = ''; }
        var columns = CreateColumn(field.Options);
        var text = '';
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var column = columns_1[_i];
            if (text != '')
                text += ' ';
            text += column.formatter(null, null, formValues[fieldId]);
        }
        if (text.trim() == '')
            return;
        this.ItemsToDisplay.push({
            text: text,
            field: field,
            label: field.Options.Label + sufix
        });
    };
    Main.prototype.SaveComplete = function (result, formValues) {
        rnJQuery(this.$refs.submit).RNWait('stop');
        this.originalSaveComplete.call(smartFormsLoadedItems[0], result, formValues);
    };
    Main = __decorate([
        Component({
            template: "<div ref=\"container\" class=\"bootstrap-wrapper\" style=\"padding:10px;border:#dfdfdf solid 1px;display:none;opacity:0;\">\n                <h1><i class=\"fa fa-bookmark\" aria-hidden=\"true\"></i> {{ReviewText}}</h1>\n                <p>{{GeneralText}}</p>\n                <div>\n                    <div class=\"row\" v-for=\"item in ItemsToDisplay\">\n                        <label class=\"col-sm-4\">{{item.label}}:</label>\n                        <div class=\"col-sm-8\">{{ item.text }}</div>\n                      </div>\n                </div>\n                <div style=\"text-align: right;\">\n                    <button class=\"btn btn-danger\" v-on:click=\"Edit\"><i class=\"fa fa-pencil\" aria-hidden=\"true\" ></i> {{EditText}}</button>\n                    <button ref=\"submit\" class=\"btn btn-success\"  v-on:click=\"Submit\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{SubmitText}}</button>\n                </div>\n            </div>"
        })
    ], Main);
    return Main;
}(Vue));
export { Main };
